<template>
  <div class="footer-bar">
    <router-link to="/videoCategory" class="footer-btn">
      最新视频
    </router-link>
    <!-- <router-link to="/Recommend" class="footer-btn">
      最新资讯
    </router-link> -->
    <!-- <router-link to="Issue" class="footer-btn" style="display:none">
      <img src="../assets/img/footer/issue_nav.png"/>
      发布需求
    </router-link> -->
    <router-link to="/testnew" class="footer-btn">
      产品信息
    </router-link>
    <router-link to="/Personal" class="footer-btn">
     个人中心
      <!-- <div class="IM-open" v-if="IMIsShow" :style="{height:clientHeight+'px', width:clientWidth+'px'}"></div>
      <div class="IM-list" @click="IMIsShowNoChange" v-if="IMIsShow">
        <a href="http://p.qiao.baidu.com/cps/chat?siteId=9759310&userId=21364156"><div>环保业务咨询</div></a>
        <a href="http://p.qiao.baidu.com/cps/chat?siteId=9759310&userId=21364156"><div>平台使用咨询</div></a>
      </div> -->
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'footer-bar',
    data () {
      return {
        IMIsShow: false,
        clientWidth: 0,
        clientHeight: 0
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        let thisScreen = document.querySelector('html').getAttribute('data-dpr')
        this.clientWidth = window.screen.width * thisScreen
        this.clientHeight = window.screen.height * thisScreen
      })
    },
    methods: {
      IMIsShowChange: function () {
        this.IMIsShow = !this.IMIsShow
      },
      IMIsShowNoChange: function () {
        this.IMIsShow = !this.IMIsShow
      }
    }
  }
</script>

<style lang="scss">
  @import "../assets/css/scss/cssrem.scss";

  $px: 1px;
  $background-img: url(../assets/img/footer/video_nav.png)  url(../assets/img/footer/consult_nav.png) url(../assets/img/footer/personal_nav.png);
  $background-img-on: url(../assets/img/footer/video_nav_on.png)  url(../assets/img/footer/consult_nav_on.png) url(../assets/img/footer/personal_nav_on.png);

  .footer-bar {
    position: fixed;
    bottom: 0;
    z-index: 100;
    width: 100%;
    display: flex;
    justify-content: space-around;
    height: px2rem(98px);
    border-top: 1px solid #dbdbdb;
    background-color: #ffffff;
  }

  .IM-open{
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 101;
    background-color: black;
    opacity: 0.3;
  }

  .IM-list{
    background: url(../assets/img/footer/IM_show.png) no-repeat;
    background-size: px2rem(240px) px2rem(240px);
    opacity: 1;
    z-index: 102;
    height: px2rem(240px);
    width: px2rem(240px);
    bottom: px2rem(90px);
    right: px2rem(25px);
    @extend .IM-open;
    div {
      line-height: px2rem(60px);
      height: px2rem(60px);
      width: px2rem(192px);
      margin: px2rem(35px) px2rem(24px);
      background-color: #00be3a;
      color: white;
      border-radius: px2rem(30px);
    }
  }

  .index .footer-btn:nth-child(1) {
    background: nth($background-img-on, 1) center px2rem(18px) no-repeat;
    color: #00be3a;
    background-size: px2rem(40px);
  }



  @mixin footer-btn {
    .footer-btn {
      font-size: px2rem(25px);
      text-align: center;
      color: #666666;
      line-height: px2rem(150px);
    }
  }

  // @mixin footer-btn3 {
  //   .footer-btn:nth-child(1) {
  //     font-size: 12*$px;
  //     font-weight: bold;
  //     img {
  //       width: px2rem(92px);
  //       position: absolute;
  //       bottom: px2rem(45px);
  //       margin-right: px2rem(10px);
  //     }
  //   }
  // }

  @for $i from 1 through length($background-img) {
    .footer-btn:nth-child(#{$i}) {
      background: nth($background-img, $i) center px2rem(18px) no-repeat;
      background-size: px2rem(40px);
    }
    @each $view,$img in (video: nth($background-img-on, 1),consult:nth($background-img-on, 2),personal:nth($background-img-on, 3)) {
      .#{$view}{
        @each $view-index,$index in (video:1,consult:2,personal:3) {
          @if $view-index==$view {
            .footer-btn:nth-child(#{$index}) {
              background: $img center px2rem(18px) no-repeat;
              color: #00be3a;
              background-size: px2rem(40px);
            }
          }
        }
      }
    }
  }

  @for $i from 1 through 3 {
    [data-dpr="#{$i}"] {
      $px: $i*1px;
      @include footer-btn;
      // @include footer-btn3;
      .IM-list div{
        font-size: $i*12px;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// footer.vue?30430cd8